export default "__VITE_ASSET__DH8Aq4_6__"